import { memo, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import cn from 'classnames';

import { hideNumber } from '../../helpers/titreHelper';
import { customIconsSources } from '../../helpers/icons';

import { MessageContent } from '../MessageContent/MessageContent';

import styles from './Message.module.css';

const Message = ({
  className,
  message,
  setDelay,
  currentState,
  duration,
  oneLineDuration,
  pauseBetweenMessages,
}) => {
  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (isFirst && currentState === 'S1') {
      setTimeout(() => {
        setIsFirst(false);
      }, 1000);
    } else if (!isFirst && currentState !== 'S1') {
      setIsFirst(true);
    }
  }, [currentState, isFirst]);

  const errorHandler = (e) => {
    e.target.src = customIconsSources['livechat'];
  };

  const initDelay = isFirst ? 0.4 : pauseBetweenMessages / 1000;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={`${message.id}`}
        className={cn(styles.wrapper, className)}
      >
        {message?.content && (
          <div className={styles.author}>
            <motion.img
              key={`${message.id}-channel`}
              src={
                customIconsSources[message.channel] ||
                customIconsSources['livechat']
              }
              className={styles.channel}
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                transition: { duration: 0.2, delay: initDelay + 0.08 },
              }}
              exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
              onError={errorHandler}
            />
            <motion.div
              key={`${message.id}-name`}
              className={styles.name}
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                transition: {
                  duration: 0.2,
                  delay: initDelay + 0.2 + 0.08,
                },
              }}
              exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
            >
              {message?.author || hideNumber(message?.senderNumber)}:
            </motion.div>
          </div>
        )}

        <motion.div
          key={`${message.id}-content`}
          className={styles.contentWrapper}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              duration: 0.2,
              delay: initDelay + 0.2 + 0.08 + 0.2 + 0.08,
            },
          }}
          exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
        >
          <MessageContent
            content={message.content}
            setDelay={setDelay}
            initDelay={initDelay}
            duration={duration}
            oneLineDuration={oneLineDuration}
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default memo(Message);
